import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AntiforgeryService } from './Antiforgery.Service';
import { ConfigurationService } from './configuration.service';
import { LocalStoreManager } from './local-store-manager.service';
import { AuthGuardService } from './authguard.service';
import { SecurityEndpoint } from './SecurityEndpoint.service';
import { SecurityService } from './security.service';
import { RegulatoryItemService } from './regulatoryitem.service';
import { RegulatoryItemEndpoint } from './regulatoryitemendpoint.service';
import { DepartmentService } from './department.service';
import { DepartmentEndpoint } from './departmentEndPoint.service';
import { UserAccessService } from './userAccess.service';
import { UserAccessEndpoint } from './userAccessEndpoint.service';
import { ReportService } from './report.service';
import { ReportEndpoint } from './reportendpoint.service';
import { EndpointFactory } from './endpoint-factory.service';
import { AlertService, MessageSeverity } from './alert.service';
import { PermitService } from './permit.service';
import { PermitEndpoint } from './permitendpoint.service';
import { PrioritySubmissionEndpoint } from './prioritysubmissionendpoint.service';
import { PrioritySubmissionService } from './prioritysubmission.service';
import { AnnualPlanEndpoint } from './annualplanendpoint.service';
import { AnnualPlanService } from './annualplan.service';
import { AnnualCountForecastEndpoint } from './annualcountforecastendpoint.service';
import { AnnualCountForecastService } from './annualcountforecast.service';


@NgModule({
  providers: [
    SecurityService,
    SecurityEndpoint,
    RegulatoryItemService,
    RegulatoryItemEndpoint,
    DepartmentService,
    DepartmentEndpoint,
    UserAccessService,
    UserAccessEndpoint,
    ReportService,
    ReportEndpoint,
    ConfigurationService,
    LocalStoreManager,
    EndpointFactory,
    AlertService,
    AuthGuardService,
    LocalStoreManager,
    ConfigurationService,
    PrioritySubmissionEndpoint,
    PrioritySubmissionService,
    AnnualPlanEndpoint,
    AnnualPlanService,
    AnnualCountForecastEndpoint,
    AnnualCountForecastService,
    PermitService,
    PermitEndpoint,
    { provide: HTTP_INTERCEPTORS, useClass: AntiforgeryService, multi: true },
  ]
})
export class ServiceProxyModule { }
